import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions, RadioSubLayer } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import legendImage from '../../img/legend_pesticide_waterworks.png'
import { ContextTag } from '../wiki/Wiki'

const defaultSubLayer: RadioSubLayer = {
  labelId: 'map.layer.pesticidewaterworks.sublayer.waterworksdesphenylchloridazon',
  subLayer: 'waterworks-desphenyl-chloridazon'
}

/**
 * Map layer class for the Pesticide Waterworks Maps WMS source from GEO.
 */
class PesticideWaterworksLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 1,
    radioSubLayers: {
      labelId: 'layerpicker.radiosublayer.pesticidewaterworks',
      selected: defaultSubLayer,
      sublayers: [
        defaultSubLayer,
        {
          labelId: 'map.layer.pesticidewaterworks.sublayer.waterworksmethyldesphenylchloridazon',
          subLayer: 'waterworks-methyl-desphenyl-chloridazon'
        },
        {
          labelId: 'map.layer.pesticidewaterworks.sublayer.waterworksnndimethylsulfamiddms',
          subLayer: 'waterworks-n-n-dimethylsulfamid-dms'
        },
        {
          labelId: 'map.layer.pesticidewaterworks.sublayer.waterworksmetalaxylsyrecga62826',
          subLayer: 'waterworks-metalaxylsyre-cga-62826'
        },
        {
          labelId: 'map.layer.pesticidewaterworks.sublayer.waterworks124triazol',
          subLayer: 'waterworks-1-2-4-triazol'
        }
      ]
    }
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.PESTICIDE_WATERWORKS,
      enabled: true,
      minZoom: 7,
      zIndex: 4
    }
    super({ ...defaultOptions, ...options })

    let { radioSubLayers, opacity } = options.params
    opacity = opacity === undefined ? PesticideWaterworksLayer.defaultParams.opacity : opacity

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'https://data.geo.dk/mapv2/geo-services/wms',
        params: {
          layers: radioSubLayers.selected.subLayer,
          token: options.token
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.PESTICIDE_WATERWORKS,
      name: 'map.layer.pesticidewaterworks',
      group: LayerGroup.POLLUTION,
      contextTags: [
        ContextTag.PESTICIDE_WATERWORKS
      ],
      themes: [DataTheme.ENVIRONMENT],
      capabilitiesUrl: '',
      legendEnabled: true,
      imageLegend: {
        legendImage: legendImage,
        imageHeight: 55,
        legendTextId: 'layerpicker.legend.text.pesticidewaterworks'
      },
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

export default PesticideWaterworksLayer
